module.exports = __webpack_public_path__ + "img/curva.ae40504a.svg";